var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcelDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "36px",
    viewBox: "0 0 28 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BC4EE17A-FD8C-4287-B840-C4E424E8776B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Loan-Creation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Loan-Creation-4",
    transform: "translate(-706.000000, -411.000000)",
    fill: "#1071EE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(450.000000, 142.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(32.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(193.000000, 169.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.2197917,10.6101563 L48.0916667,0.748828125 C47.9276042,0.590625 47.7489583,0.45703125 47.5557292,0.34453125 C47.5046875,0.31640625 47.4536458,0.28828125 47.3989583,0.263671875 C47.3661458,0.24609375 47.3296875,0.23203125 47.296875,0.21796875 C46.96875,0.07734375 46.6078125,0 46.2395833,0 L33.6614583,0 C32.2104167,0 31,1.13203125 31,2.53125 L31,33.46875 C31,34.8679687 32.2104167,36 33.6614583,36 L56.375,36 C57.8260417,36 58.9635417,34.8679687 58.9635417,33.46875 L58.9635417,12.3925781 C58.9635417,11.7246094 58.7083333,11.0847656 58.2197917,10.6101563 Z M47.5885417,3.88125 L54.909375,10.96875 L47.5885417,10.96875 L47.5885417,3.88125 Z M56.3385417,33.46875 L33.625,33.46875 L33.625,2.53125 L44.9635417,2.53125 L44.9635417,10.96875 C44.9635417,12.3679688 46.1739583,13.5 47.625,13.5 L56.3385417,13.5 L56.3385417,33.46875 Z",
    id: "Icon-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelDoc);
export default __webpack_public_path__ + "static/media/excel-doc.1bddbef9c92db4e8e0d7473da3cef1df.svg";
export { ForwardRef as ReactComponent };